import * as React from 'react';
import { observer } from 'mobx-react-lite';

export default observer(
    function CalendarDefaultSurfaceComponent(
        {
            className,
            style,
            children,
            handlers,
        }: {
            className?: string;
            style?: React.CSSProperties;
            children?: React.ReactNode;
            handlers?: React.DOMAttributes<HTMLDivElement>;
        },
        ref: (e: HTMLElement) => void
    ) {
        return (
            <div className={className} style={style} {...handlers} ref={ref}>
                {children}
            </div>
        );
    },
    { forwardRef: true }
);
